/**
 * The paper exams that exist, by provider-level slug, with their booklet
 * config loaded on demand (the paper code stays out of the main bundle).
 */
export const PAPER_LEVELS = {
  'telc-b1': { label: 'telc Deutsch B1', load: () => import('./telcB1/level.js') },
  'telc-b2': { label: 'telc Deutsch B2', load: () => import('./telcB2/level.js') },
  'telc-c1': { label: 'telc Deutsch C1 Hochschule', load: () => import('./telcC1/level.js') },
  'goethe-b1': { label: 'Goethe-Zertifikat B1', load: () => import('./goetheB1/level.js') },
  'goethe-b2': { label: 'Goethe-Zertifikat B2', load: () => import('./goetheB2/level.js') },
  'goethe-c1': { label: 'Goethe-Zertifikat C1', load: () => import('./goetheC1/level.js') },
  'osd-b1': { label: 'ÖSD Zertifikat B1', load: () => import('./osdB1/level.js') },
  'osd-b2': { label: 'ÖSD Zertifikat B2', load: () => import('./osdB2/level.js') },
  'osd-c1': { label: 'ÖSD Zertifikat C1', load: () => import('./osdC1/level.js') },
};
